import { Box, Typography } from '@mui/material'
import React from 'react'
import { ActionButton } from './../../../../components'
import { ArrowForward, QuestionAnswer } from '@mui/icons-material'
import { useHomeEnterpriseContext } from './../../context/home-enterprise-page-context'
import { useTrackHomeEnterpriseEvent } from '../../hooks/useTrackHomeEnterpriseEvent'
import { HOME_SECTION_TYPE } from './home-sections'
import { useSelector } from 'react-redux'
import { userSlice } from '../../../../reducers'
import { useFormFactor } from '../../../../hooks'

export const OnboardingSection = () => {
  const { setOnboardingOpen } = useHomeEnterpriseContext()
  const { trackClickEvent } = useTrackHomeEnterpriseEvent()
  const isProfileLoaded = useSelector(userSlice.selectors.selectIsProfileLoaded)
  const { isMobile } = useFormFactor()
  const handleOnboardingClick = () => {
    trackClickEvent(HOME_SECTION_TYPE.ONBOARDING, {
      action: 'start'
    })
    setOnboardingOpen(true)
  }

  return (
    <Box
      sx={{
        background: '#FEFCFF',
        border: '1px solid #DDDBE0',
        p: 4,
        borderRadius: '4px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: { sm: 'center' },
        flexDirection: { xs: 'column', sm: 'row' },
        gap: 2,
        width: '100%'
      }}
      data-test='home-onboarding-rails'
    >
      <Box sx={{ flex: 1 }}>
        <Box display='flex' alignItems='center' gap={1} mb={1}>
          <QuestionAnswer color='primary' />
          <Typography sx={({ typography }) => ({ fontWeight: 700, ...typography.body.l })}>Get content tailored to you.</Typography>
        </Box>
        <Typography sx={{ width: { xs: '100%', sm: '80%' }, color: '#18191A' }}>
          Answer 3 quick questions to personalize your experience.
        </Typography>
      </Box>
      <Box sx={{ width: { xs: '100%', sm: 'auto' }, textAlign: 'center' }}>
        <ActionButton
          variant='primary'
          label='Get Started'
          onClick={handleOnboardingClick}
          loading={!isProfileLoaded}
          fullWidth={isMobile}
          endIcon={<ArrowForward />}
          data-test='onboarding-section-start-button'
        />
      </Box>

    </Box>
  )
}
